import Vue from 'vue'
import Vuex from 'vuex'
import seller from "./seller";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    downloadUrl: 'https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/apk/download/qianshoushou.apk',
    arrowImg: 'https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/resources/images/mine_arrow%402x.png',
    newNotice: '',
    /** 域名信息 */
    domainInfo: {}
  },
  mutations: {
    downloadApp() {
      if(this.isWeChat) {
        this.isShowMask = true
        return
      }
      const agent = navigator.userAgent;
      const isIos = !!agent.match(/\Mac OS X/)
      if(isIos) {
        console.log('苹果')
        window.location.href = "itms-apps://itunes.apple.com/app/id1567163324"
      } else {
        window.location.href = this.$store.state.downloadUrl;
      }
    },
    //更新公告
    setNotice(state, value) {
      state.newNotice = value;
    },
    setDomain(state, value) {
      state.domainInfo = value;
    }
  },
  modules: {
    seller
  }
})
